export const machineDetail = state => state.machineDetail;
export const machineBanner = state => state.machineBanner;
export const menuData = state => state.menuData;
